<template>
<el-tooltip :disabled="tooltip === ''" :content="tooltip" :placement="tooltipplacement" :open-delay="50">
  <div class="body" :style="{backgroundColor: background}">
    <div class="stat" :style="{color: statColor}">{{ stat }}</div>
    <div class="label" :style="{color: labelColor}">{{ label }}</div>
  </div>
</el-tooltip>
</template>

<script>
export default {
  name: 'RepeatStat',
  props: {
    stat: [String, Number],
    label: String,
    statColor: {
      type: String,
      default: "black"
    },
    labelColor: {
      type: String,
      default: "black"
    },
    background: {
      type: String,
      default: "#B3CDE0"
    },
    tooltip: {
      type: String,
      default: ''
    },
    tooltipplacement: {
      type: String,
      default: 'top'
    }
  }
}
</script>

<style scoped>
div.body {
  padding: 10px;
  margin: 10px;
  flex: 1;
  border-radius: 1px;
}

div.body:hover {
  transition: all 0.2s;
  box-shadow: 0px 2px 10px 1px lightgrey;
}

div.stat {
  font-family: 'Unica One', Arial, Helvetica, sans-serif;
  font-size: 2em;
}

div.label {
  font-family: 'Oxygen', Arial, Helvetica, sans-serif;
}
</style>
